import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@nucleus-commerce/ui/components/form';
import { ToggleGroup, ToggleGroupItem } from '@nucleus-commerce/ui/components/toggle-group';

import { railSourceTypes, type RailFormInput } from '../../schemas/block-form-schema';

export interface RailSourceFieldsProps {
  /** Null for a shared rail: only hand-picked products exist there. */
  storeId: string | null;
}

/** Segmented control: from a collection or hand-picked. Shared rails only get the latter. */
export function RailSourceFields({ storeId }: RailSourceFieldsProps) {
  const { t } = useTranslation('content');
  const form = useFormContext<RailFormInput>();
  const sources = railSourceTypes.filter((source) => storeId !== null || source === 'products');

  return (
    <FormField
      control={form.control}
      name="sourceType"
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t('rail.source')}</FormLabel>
          <FormControl>
            <ToggleGroup
              type="single"
              variant="outline"
              value={field.value}
              onValueChange={(next) => {
                if (next !== '') field.onChange(next);
              }}
              aria-label={t('rail.source')}
              className="w-full sm:w-fit"
            >
              {sources.map((source) => (
                <ToggleGroupItem key={source} value={source} className="flex-1 px-4 sm:flex-none">
                  {t(`rail.sources.${source}`)}
                </ToggleGroupItem>
              ))}
            </ToggleGroup>
          </FormControl>
          <FormDescription>
            {storeId === null ? t('rail.sharedNote') : t(`rail.sourceHints.${field.value}`)}
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
